export default "/images/887775f80d078ca9dcad3bfe3c1ff90e.avif";